<template>
<div>
  <div class="alert_msg " id="set_password" >
	<div class="alert_msg_pos">
		<div class="alert_msg_dialog">
			<div class="alert_msg_header">
				<div id="alert_title">密码</div>
				<div>
					<div id="alert_icon"><img src="/static/image/popup_password.png"></div>
				</div>
			</div>
			<div class="alert_msg_body">
				<div class="msg_show"></div>
				<div class="form_show"><form>
				<div class="error_msg_all validation" style="color:red;text-align: center;font-size: 10px;margin-bottom: 16px;"></div>
				<label class="textbox_content">
					<input type="password" name="old_password" id="old_password" placeholder="旧密码"  v-model="passwordInfo.password"  maxlength="15" class="pw">
					<span toggle="#old_password" class="icon-eye_close toggle_password"></span>
				</label>
				<div class="error_msg_old_password validation" style="color:red;text-align: left;font-size: 10px;margin-bottom: 16px;"></div>
				<label class="textbox_content">
					<input type="password" name="password" placeholder="新密码（最少8位，英文及数字）" v-model="passwordInfo.paypassword" id="new_password" maxlength="15" class="pw">
					<span toggle="#new_password" class="toggle_password icon-eye_close"></span>
				</label>
				<!--label class="textbox_content">                     
					<div class="password_secure_level_container default" id="secure_level">
						<div class="password_secure_level">
							<div></div><div></div><div></div>
						</div>
						<span></span>
					</div>
				</label-->
				<div class="error_msg_password validation" style="color:red;text-align: left;font-size: 10px;margin-bottom: 16px;"></div>
				<label class="textbox_content">
					<input type="password" name="password_confirmation" placeholder="再输入一次新的帐号密码" v-model="passwordInfo.newpasword" id="password_confirmation" maxlength="15" class="pw">
					<span toggle="#password_confirmation" class="toggle_password icon-eye_close"></span>
				</label>
				<div class="error_msg_password_confirmation validation" style="color:red;text-align: left;font-size: 10px;margin-bottom: 16px;"></div>
				</form></div>
				<div class="button_area"><div class="confirm_btn"><button class="btn w-100" @click="editPassword(1)" >保存</button></div><div class="cancel_btn" @click="clreaInfo"><a>取消</a></div></div>
			</div>
		</div>
	</div>
</div>
  <div class="subpage main_area">
    <div class="player_profile player_profiledetails layout intl_profile_layout profile_player">
      <div class="player_profile_bg safety">
        <div class="detail_area">
          <div class="img_block">
            <svg class="progress-ring" width="76" height="76">
              <circle stroke="#FFF" stroke-width="2" fill="transparent" r="32" cx="38" cy="38"></circle>
              <circle class="progress-ring__circle" stroke="#00BA91" stroke-width="3" fill="transparent" r="32" cx="38" cy="38"></circle>
            </svg>
            <img alt="" style="border-radius: 50%" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/avatar_profile.png'" />
            <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" /> 
          </div>
          <div class="name_block">
            <div><span class="fullname">{{ $store.state.userInfo.username || '' }} </span> {{ $store.state.userInfo.current_vip  }}</div>
            <div><a class="btn mini btn_trans_white set_password btn_my_pwd active" @click="changShow">密码管理</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="player_profiledetails_form layout intl_profile_form">
      <div class="tips_block">温馨提示：绑定资料让账户更加安全！一经绑定，不可随意修改，如需修改，请联系24小时在线客服为您服务。</div>
      <div id="profile_form">
        <label class="textbox_content">
          <input type="text" placeholder="中文真实姓名" :value="$store.state.userInfo.realname" disabled name="full_name" id="full_name" maxlength="10" class="fn pdinput" />
          <div class="input_title"></div>
          <div class="error_msg full_name_error"></div>
        </label>
        <label class="textbox_content d-flex align-items-center">
          <input type="text" placeholder="手机号"  v-model="mobile"  name="mobile_number" id="mobile_number" class="mn pdinput" maxlength="11" />
          <div class="input_title"></div>
          <div class="error_msg mobile_number_error"></div>
        </label>
        <label class="textbox_content">
          <input type="text" placeholder="电子邮箱" v-model="email" name="email" id="email" class="email pdinput" />
          <div class="input_title"></div>
          <div class="error_msg email_error"></div>
        </label>
        <label class="textbox_content" id="label_dob">
          <input type="text" placeholder="出生日期" v-model="birthday" id="my_dob" name="dob" class="pdinput" />
          <div class="input_title_static"></div>
          <div class="error_msg"></div>
        </label>
        <label class="textbox_content" >
     
    
        <div class="textbox_content btn_medium">
          <button class="btn profile_btn btn_major" @click="isOk" type="button">保存</button>
        </div>
        </label>

      </div>
    </div>
  </div>
</div>

</template>
<script>
export default {
  name: 'account',
  data() {
    return {email:null,mobile:null,birthday:null,passwordInfo:{}};
  },
  created() {
    let that = this;
     let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    that.mobile = userInfo.mobile;
    that.email = userInfo.email;
    that.birthday = userInfo.birthday;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
        editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, that.passwordInfo).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, '密码修改成功！');
          that.passwordInfo = {};
          that.clreaInfo();
          if (pasType == 1) {
            sessionStorage.setItem('token', '');
            that.$store.commit('changToken');
            that.$router.push({ path: '/' });
          }
        }
      });
    },
        clreaInfo() {
      this.passwordInfo = {};
      this.info = {};
      this.cardInfo = {};
 setTimeout(function () {
        $('.alert_msg').removeClass('active');

        $('.alert_msg').removeClass('delay');
        alertCheck = true;
      }, 1500);
    
    },
    changShow(){
      $('#set_password').addClass('active').addClass('delay');

      this.passwordInfo = {};
    },
        isOk() {
      let that = this;
      let info = { email: that.email, mobile: that.mobile, birthday: that.birthday };
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let dateFormat = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, '请输入正确邮箱号');
        return;
      }
      if (!dateFormat.test(that.birthday)) {
        that.$parent.showTost(0, '请输入正确的日期格式：YYYY-MM-DD');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/updateuserinfo', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.mobile = info.mobile;
            userInfo.email = info.email;
            userInfo.birthday = info.birthday;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1, '操作成功');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
        onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading()
      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfo()
          that.$parent.hideLoading();

      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.select2-container--default .select2-results > .select2-results__options {
  max-height: calc(100vw / 2) !important;
}
.player_profile_bg.safety .detail_area {
    background:url("/static/style/bg_profile.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /* background-color: var(--card_safety_bg); */
    border: var(--card_safety_borderthick) solid var(--card_safety_border);
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/account.vue